import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("tiramessi_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("tiramessi_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tiramessi_token", data.token);
    // charge les permissions effectives
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      return me.data;
    } catch {
      setUser(data.user);
      return data.user;
    }
  };

  const logout = () => {
    localStorage.removeItem("tiramessi_token");
    setUser(false);
  };

  const isAdmin = user?.role === "admin";
  const perms = user?.perms || null;

  // Vérifie une permission de rubrique : can(section, action)
  const can = (section, action = "view") => {
    if (isAdmin) return true;
    if (!perms) return false;
    return !!perms.sections?.[section]?.[action];
  };
  // Vérifie une permission spécifique (voir_couts, modifier_prix, ...)
  const canSpecial = (key) => {
    if (isAdmin) return true;
    if (!perms) return false;
    return !!perms.specials?.[key];
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, isAdmin, perms, can, canSpecial }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
